import { localization } from "../localizationManager";

export var germanStrings = {
  groupButton: "Gruppieren",
  ungroupButton: "Gruppierung aufheben",
  selectButton: "Mich auswählen",
  hideColumn: "Spalte ausblenden",
  showColumn: "Spalte einblenden",
  makePrivateColumn: "Spalte privat machen",
  makePublicColumn: "Spalte veröffentlichen",
  moveToDetail: "in Details verschieben",
  showAsColumn: "Als Spalte anzeigen",
  filterPlaceholder: "Suche...",
  removeRows: "Zeilen entfernen",
  showLabel: "anzeigen",
  entriesLabel: "Einträge",
  visualizer_text: "Texte in Tabellenform",
  visualizer_wordcloud: "Wordcloud",
  visualizer_histogram: "Histogramm",
  visualizer_number: "Durchschnitt",
  visualizer_choices: "Liste",
  visualizer_selectBase: "Diagrammtyp",
  chartType_bar: "Balkendiagramm",
  chartType_vbar: "Balkendiagramm vertikal",
  chartType_stackedbar: "Gestapeltes Balkendiagramm",
  chartType_doughnut: "Donut-Diagramm",
  chartType_pie: "Kreisdiagramm",
  chartType_scatter: "Punktediagramm",
  chartType_gauge: "Pegeldiagramm",
  chartType_bullet: "Aufzählungsdiagramm",
  hideButton: "Ausblenden",
  makePrivateButton: "Privat machen",
  makePublicButton: "Öffentlich machen",
  showButton: "Anzeigen",
  filter: "Filter",
  resetFilter: "Filter zurücksetzen",
  changeLocale: "Lokalisierung ändern",
  clearButton: "Einstellungen löschen",
  addElement: "Wählen Sie eine Frage, um zu zeigen...",
  defaultOrder: "Standardreihenfolge",
  ascOrder: "Aufsteigend",
  descOrder: "Absteigend",
  showMinorColumns: "Kleinere Spalten anzeigen",
  otherCommentTitle: "Andere Punkte und Kommentare",
  showPercentages: "Prozentsätze anzeigen",
  hidePercentages: "Prozentsätze ausblenden",
  pdfDownloadCaption: "PDF",
  xlsxDownloadCaption: "Excel",
  csvDownloadCaption: "CSV",
  saveDiagramAsPNG: "Diagramm als png herunterladen",
  hideEmptyAnswers: "Leere Antworten ausblenden",
  showEmptyAnswers: "Leere Antworten anzeigen",
  "topNValueText-1": "Alle Antworten",
  topNValueText5: "Top 5 Antworten",
  topNValueText10: "Top 10 Antworten",
  topNValueText20: "Top 20 Antworten",
  hideMissingAnswers: "Fehlende Antworten ausblenden",
  showMissingAnswers: "Fehlende Antworten anzeigen",
  missingAnswersLabel: "Fehlede Antworten",
  noVisualizerForQuestion: "Für diesen Fragetyp gibt es noch keine Visualisierung.",
  noResults: "Es liegen noch keine Ergebnisse vor",
  showPerValues: "Pro Wert",
  showPerColumns: "Pro Spalte",
  answer: "Antwort",
  correctAnswer: "Korrekte Antwort: ",
  percent: "Prozent",
  responses: "Antworten"
};
localization.locales["de"] = germanStrings;
localization.localeNames["de"] = "Deutsch";
